export default "__VITE_ASSET__vtEGDrJQ__"